import { IntakeStatus, PrequalifiedStatus } from "@finni-health/shared";

export const isPrequalifiedStatus = (status: IntakeStatus) => {
  return Object.keys(PrequalifiedStatus).includes(status);
};
